import ProductCard from 'sections/product/partials/ProductCard';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import modulesMap from 'core/modulesMap';
class BlockProducts extends Component {
    currentItem = 0;
    fraction = 0;
    initialized() {
        super.initialized();
        this.fraction = this.refs.articleProductsSlider.scrollWidth / this.refs.items.length;
    }
    getModulesMap() {
        return {
            ...modulesMap,
            productCard: ['.product-card', ProductCard]
        };
    }
    getModuleParams(el, componentConstructor) {
        {
            return {
                parent: this,
                pageManager: this.options.pageManager
            };
        }
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.articleProductsSlider[method]('scroll', this.onScroll);
        if (this.refs.prev && this.refs.next) {
            this.refs.prev[method]('click', (e) => this.navigateItem(e, -1));
            this.refs.next[method]('click', (e) => this.navigateItem(e, 1));
        }
    }
    navigateItem(e, direction) {
        e.preventDefault();
        if (this.currentItem + direction < 0 || this.currentItem + direction >= this.refs.items.length - 2)
            return;
        this.setButtonDisabledState(this.currentItem);
        this.currentItem += direction;
        this.refs.articleProductsSlider.scrollTo({
            left: this.currentItem * this.fraction,
            behavior: 'smooth'
        });
    }
    onScroll = () => {
        this.currentItem = Math.round(this.refs.articleProductsSlider.scrollLeft / this.fraction);
        this.setButtonDisabledState(this.currentItem);
        const progress = this.refs.articleProductsSlider.scrollLeft / (this.refs.articleProductsSlider.scrollWidth - this.refs.articleProductsSlider.clientWidth);
        this.refs.articleProductsTrack.style.transform = `translateX(${progress * (100) * (this.refs.items.length - 1)}%)`;
    };
    setButtonDisabledState(current) {
        if (this.refs.prev)
            this.refs.prev.classList.toggle('disabled', current === 0);
        if (this.refs.next)
            this.refs.next.classList.toggle('disabled', current === this.refs.items.length - 3);
    }
}
export default BlockProducts;
